export default __webpack_public_path__ + "static/media/Mtr.f73aaf77.png";